/* Generated by tools/build_sections.py from brand/hbsim.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_hbsim)return;window.__efEnergy_hbsim=1;
/* The home-battery day simulator.
 *
 * Ported VERBATIM from the design handoff. The handoff is explicit: "Port the
 * function exactly and unit-test it — every figure on the tariff page comes
 * out of it." So the arithmetic below is not improved, tidied or refactored;
 * only its inputs are made explicit instead of module-global, so the unit
 * tests can drive it and so the tariff can be changed in one place.
 *
 * CONSTANTS AND THEIR STANDING (data/tariff-MY.json):
 *   HB_KWH 5.02 per module   VERIFIED — matches EcoFlow's published OCEAN 2
 *                            LFP 5 kWh spec (46 kg, 279 mm match too)
 *   peak RM 0.4959 / off RM 0.4550, 14:00-22:00 Mon-Fri
 *                            SOURCED, 12OCT2026. Domestic ToU under RP4,
 *                            effective 1 July 2025, from mytnb.com.my/tariff:
 *                            energy 28.52 peak / 24.43 off-peak sen per kWh
 *                            for <=1500 kWh a month, plus capacity 4.55 and
 *                            network 12.85, both flat. The owner's own
 *                            September 2026 TNB bill independently confirms
 *                            capacity 4.55, network 12.85 and the general
 *                            energy charge 27.03, and gives the AFA at 3.67
 *                            sen for that month -- which applies because this
 *                            profile draws 857 kWh and AFA starts above 800.
 *                            28.52+4.55+12.85+3.67 = 49.59 sen.
 *                            24.43+4.55+12.85+3.67 = 45.50 sen.
 *                            THE AFA MOVES MONTHLY (3.61 sen in October), so
 *                            these are current, not permanent.
 *                            What they REPLACE: 0.57 was the pre-RP4 peak
 *                            (57.10 sen), superseded for sixteen months, and
 *                            0.45 was TNB's average basic tariff (45.40 sen)
 *                            standing in for an off-peak rate. The pair put
 *                            the peak/off-peak spread at 12 sen where the
 *                            real one is 4.09 -- nearly 3x -- and the spread
 *                            is what load-shifting actually earns.
 *                            Peak is 14:00-22:00 MONDAY TO FRIDAY; Saturday,
 *                            Sunday and public holidays are off-peak for all
 *                            24 hours.
 *                            The page must keep its "savings depend on your
 *                            usage" caveat (handoff §7).
 *
 * Every figure this returns is therefore an ESTIMATE on unconfirmed rates.
 * Nothing here may be presented as a guaranteed saving (F2.L8, CPA 1999).
 */
(function (root) {
  'use strict';

  var DEFAULTS = {
    kwh: 5.02,
    ratePeak: 0.4959,
    rateOff: 0.4550,
    peakFrom: 14,
    peakTo: 22,
    pv:   [0, 0, 0, 0, 0, 0, 0.1, 0.7, 1.9, 3.5, 5.2, 6.6, 7.2, 6.9, 5.8, 4.4, 2.8, 1.2, 0.3, 0, 0, 0, 0, 0],
    load: [1.1, 1.0, 1.0, 1.0, 1.0, 0.9, 1.0, 1.5, 0.9, 0.7, 0.7, 0.8, 0.9, 0.9, 0.8, 0.7, 0.8, 1.0, 1.7, 2.2, 2.4, 2.2, 1.7, 1.3],
    startSoc: 0.25,
    floorSoc: 0.10,
    dawnTopUpTo: 0.55,
    dawnBefore: 5,
    chargeKwPerModule: 2.5,
    dischargeKwPerModule: 3.4
  };

  function isPeak(h, c) { return h >= c.peakFrom && h < c.peakTo; }

  function hbSim(mods, invKw, cfg) {
    var c = Object.assign({}, DEFAULTS, cfg || {});
    var cap = mods * c.kwh;
    var chgMax = Math.min(mods * c.chargeKwPerModule, invKw);
    var dchMax = Math.min(mods * c.dischargeKwPerModule, invKw);
    var soc = cap * c.startSoc;
    var hours = [];
    var grid = 0, own = 0, load = 0, cost = 0, base = 0;

    for (var h = 0; h < 24; h++) {
      var pv = c.pv[h], ld = c.load[h];
      var rate = isPeak(h, c) ? c.ratePeak : c.rateOff;
      var solar = Math.min(pv, ld);
      var need = ld - solar, surplus = pv - solar;
      var charged = 0, batt = 0, fromGrid = 0, topUp = 0;

      if (surplus > 0) { charged = Math.min(surplus, chgMax, cap - soc); soc += charged; }
      if (need > 0) {
        var avail = Math.max(0, soc - cap * c.floorSoc);
        batt = Math.min(need, dchMax, avail);
        soc -= batt;
        fromGrid = need - batt;
      }
      if (h < c.dawnBefore && soc < cap * c.dawnTopUpTo) {
        topUp = Math.max(0, Math.min(chgMax - charged, cap * c.dawnTopUpTo - soc));
        soc += topUp;
      }

      hours.push({ h: h, pv: pv, load: ld, solar: solar, batt: batt, grid: fromGrid,
                   chg: charged, topUp: topUp, soc: soc,
                   // guarded: cap is mods * kwh, and mods 0 is a real input
                   socPct: cap > 0 ? Math.round(soc / cap * 100) : 0,
                   peak: isPeak(h, c) });
      grid += fromGrid + topUp; own += solar + batt; load += ld;
      cost += (fromGrid + topUp) * rate; base += ld * rate;
    }

    /* TWO FIGURES, AND ONLY ONE OF THEM IS THE BATTERY'S.
     *
     * `saved` (base - cost) is what the ported model returns, and it credits
     * the battery with the SOLAR's self-consumption too: run this with zero
     * modules and it still reports a saving, because the house has panels.
     * Publishing that number beside a battery price would attribute the
     * solar's value to the battery (F2.L8, CPA 1999).
     *
     * `savedByBattery` is the honest one: this system's cost against the SAME
     * house with the same solar and no battery. The ported arithmetic above is
     * untouched — this is an addition, not a correction. */
    var solarOnlyCost = 0;
    for (var j = 0; j < 24; j++) {
      var r2 = isPeak(j, c) ? c.ratePeak : c.rateOff;
      solarOnlyCost += Math.max(0, c.load[j] - Math.min(c.pv[j], c.load[j])) * r2;
    }

    return { hours: hours, cap: cap, chgMax: chgMax, dchMax: dchMax,
             solarOnlyCost: solarOnlyCost,
             savedByBattery: solarOnlyCost - cost,
             grid: grid, own: own, load: load, cost: cost, base: base,
             saved: base - cost,
             selfPct: load > 0 ? Math.round(own / load * 100) : 0 };
  }

  hbSim.DEFAULTS = DEFAULTS;
  hbSim.isPeak = isPeak;
  root.hbSim = hbSim;
  if (typeof module !== 'undefined' && module.exports) module.exports = hbSim;
})(typeof window !== 'undefined' ? window : globalThis);

})();
